import widgets from "./index";
import { Suspense } from "react";

const App = ({ data, ...props }) => {
  let isParsed = false;

  if (typeof data == "string" && !isParsed) {
    try {
      data = JSON.parse(data);
      Object.keys(data).forEach(key => {
        props[key] = data[key];
      });
      isParsed = true;
    } catch (err) {
      console.warn("widget.solutions: data-props-data received invalid json");
    }
  }

  if (typeof data == "string" && !isParsed) {
    try {
      let parsed = atob(data);
      data = JSON.parse(parsed);
      Object.keys(data).forEach(key => {
        props[key] = data[key];
      });
      isParsed = true;
    } catch (err) {
      console.warn(
        "widget.solutions: data-props-data received invalid base64 string"
      );
    }
  }

  if (!isParsed) {
    console.warn("widget.solutions: data-props-data invalid data passed");
    return null;
  }

  let Widget = widgets?.[props?.type] ?? (widgets?.default || (() => null));

  
  if (Widget) {
    return (
      <Suspense fallback={null}>
        <Widget {...props}></Widget>
      </Suspense>
    );
  } else return null;
};

export default App;
